export default __webpack_public_path__ + "static/media/imageplaceholder.8398370f.jpg";